import type { IntlShape } from 'react-intl';
import type { AppManifest } from '@api/apps';
import { displayFormats } from '../appFormats';

export const takesOf = (intl: IntlShape, { inputs }: AppManifest): string => {
  if (inputs.maxFiles === 0) return intl.formatMessage({ id: 'apps.run.info.takesNothing', defaultMessage: 'No files' });
  const formats = displayFormats(inputs.acceptedExtensions).join(', ');
  const count =
    inputs.minFiles === inputs.maxFiles
      ? intl.formatMessage(
          { id: 'apps.run.info.files', defaultMessage: '{count, plural, one {# file} other {# files}}' },
          { count: inputs.maxFiles },
        )
      : intl.formatMessage(
          { id: 'apps.run.info.fileRange', defaultMessage: '{min}–{max} files' },
          { min: inputs.minFiles, max: inputs.maxFiles },
        );
  return formats ? `${formats} · ${count}` : count;
};

export const returnsOf = ({ deliverable }: AppManifest): string | null => {
  const formats = displayFormats(deliverable?.extensions ?? []);
  return formats.length > 0 ? formats.join(', ') : null;
};
